export function builderCaseFactory(cases) {
  const actionNames = Object.keys(cases);

  return (builder) =>
    actionNames.reduce(
      (builder, caseName) => builder.addCase(caseName, cases[caseName]),
      builder
    );
}
